import PropTypes from 'prop-types';
import React from 'react';

import ImageWithFallback from '../ImageWithFallback/ImageWithFallback.jsx';

import config from '../../config/index.js';

import './PreviewPhoto.scss';

class PreviewPhoto extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            imageNotFound: !props.imageUrl,
        };

        this.onError = this.onError.bind(this);
    }

    onError() {
        this.setState({
            imageNotFound: true,
        });
    }

    render() {
        const className = ['preview-photo'];
        const alt = [this.props.yearMakeModel];

        if (this.state.imageNotFound) {
            className.push('has-no-photo');
            alt.push('has no display');
        }

        return (
            <div className="preview-photo-wrapper">
                <ImageWithFallback
                    alt={alt.join(' ')}
                    className={className.join(' ')}
                    imageUrl={this.props.imageUrl}
                    fallbackImageUrl={`${config.source.image}/ir/w360h270/images/${this.props.noPhotoUrl}`}
                    onError={this.onError}
                />
                {!this.state.imageNotFound &&
                    this.props.pictures.length > 1 && (
                        <p className="preview-photo-text">+ {this.props.pictures.length}</p>
                    )}
            </div>
        );
    }
}

PreviewPhoto.propTypes = {
    imageUrl: PropTypes.string.isRequired,
    noPhotoUrl: PropTypes.string.isRequired,
    pictures: PropTypes.arrayOf(
        PropTypes.oneOfType([
            PropTypes.shape({
                url: PropTypes.string.isRequired,
                src: PropTypes.string.isRequired,
            }),
            PropTypes.string.isRequired,
        ])
    ).isRequired,
    yearMakeModel: PropTypes.string.isRequired,
};

PreviewPhoto.displayName = 'NewTile.PreviewPhoto';

export default PreviewPhoto;
